import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useRef} from 'react';
import NavLeftSvg from '../svg/home/NavLeftSvg';
import NavRightSvg from '../svg/home/NavRightSvg';
import DivLineSvg from '../svg/home/DivLineSvg';
import Wechat from '../svg/home/Wechat'
import './nav.css'
const Nav = ({scrollRef, handleSetRightNav, onlyIcon=false}) => {
    const location = useLocation()
    const [curScreen, setCurScreen] = useState('/')
    const refToScroll = useRef(null)
    const [isScrolled, setIsScrolled] = useState(false)
    const [relative, setRelative] = useState('')
    const navigate = useNavigate()
    const navigating = (path) => navigate(path)
    useEffect(() => {
        console.log(location.pathname)
        setCurScreen(location.pathname)
        if(location.pathname === '/newlanding/'){
            setRelative('./')
        }else{
            setRelative('../')
        }
    }, [location])
    function scrolling(){
        refToScroll.current.scrollIntoView({ behavior: 'smooth' });
    }
    
    useEffect(() => {
        if(!scrollRef?.current) return;
        const controller = new AbortController()

        scrollRef.current.addEventListener('scroll', () => {
        setIsScrolled(scrollRef.current.scrollTop > 0)
        }, { signal: controller.signal });
        
        return () => {
            controller.abort()
        };
    }, []);
    if(curScreen==='/register')return null

    return (
        <>
            <div ref={refToScroll} className='w-full h-[7vh] flex justify-between items-center sticky absolute top-0 bg-white' style={{zIndex:99999}}>
                <div className='absolute top-0 left-0 w-full h-full flex flex-row items-center justify-between d-show-m-hidden px-8'>
                    {isScrolled && 
                    <div className='bg-white absolute cursor-pointer' onClick={() => navigating('/newlanding/')}>
                        <img className='w-[133px] appear_opacity cursor-pointer' src={`${relative}img/home/top_banner_icon.png`} style={{aspectRatio:489/141}}></img>
                    </div>
                    }
                    {onlyIcon && 
                    <div className='bg-white absolute cursor-pointer' onClick={() => navigating('/newlanding/')}>
                        <img className='w-[133px] appear_opacity cursor-pointer' src={`${relative}img/home/top_banner_icon.png`} style={{aspectRatio:489/141}}></img>
                    </div>
                    }
                    
                    {!onlyIcon ? <NavLeftSvg onClick={scrolling} className={!isScrolled ? 'appear_opacity' : ''}/> : <div></div>}
                    <nav className='h-full'>
                        <ul className='d-flex-m-hidden h-full flex-row items-center justify-center cursor-pointer'>
                                <li onClick={() => navigating('/newlanding/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative'>
                                    首頁
                                    {curScreen === '/newlanding/' && <div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                                </li>
                                <li onClick={() => navigating('/newlanding/aboutus/')} className='h-full px-6 flex flex-col items-center justify-center relative'>
                                    關於T.Gather
                                    {curScreen === '/newlanding/aboutus/' && <div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                                </li>
                                <li onClick={() => navigating('/newlanding/specialties/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative'>
                                    平台特色
                                    {curScreen === '/newlanding/specialties/' &&<div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                                </li>
                                <li onClick={() => navigating('/newlanding/register/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative'>
                                    登記
                                    {curScreen === '/newlanding/register/' &&<div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                                </li>
                        </ul>
                    </nav>
                    <div className='d-flex-m-hidden flex-row items-center justify-center' style={{gap:'14px'}}>
                        <NavRightSvg className='cursor-pointer'/>
                        <Wechat className='cursor-pointer'/>
                    </div>
                    <div className='w-full absolute bottom-0 left-0'>
                        <DivLineSvg />
                    </div>
                </div>
                <div className='absolute top-0 left-0 w-full h-full flex flex-row items-center justify-between d-hidden-m-show px-8'>
                    {(isScrolled && !onlyIcon) && 
                        <div className='bg-white absolute' onClick={() => navigating('/newlanding/')}>
                            <img className='w-[133px] appear_opacity cursor-pointer' src={`${relative}img/home/top_banner_icon.png`} style={{aspectRatio:489/141}}></img>
                        </div>
                    }
                    {onlyIcon && 
                    <div className='bg-white absolute cursor-pointer' onClick={() => navigating('/newlanding/')}>
                        <img className='w-[133px] appear_opacity cursor-pointer' src={`${relative}img/home/top_banner_icon.png`} style={{aspectRatio:489/141}}></img>
                    </div>
                    }
                    <NavLeftSvg onClick={scrolling} className={(!isScrolled) ? 'appear_opacity' : ''}/>
                    
                    <div className='flex flex-col items-center justify-center w-[20px] cursor-pointer select-none' onClick={() => handleSetRightNav(true)} style={{gap:'2px'}}>
                        <div className='h-[3px] w-[20px] bg-[#b39c68]'></div>
                        <div className='h-[3px] w-[20px] bg-[#b39c68]'></div>
                        <div className='h-[3px] w-[20px] bg-[#b39c68]'></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Nav;